import suiteService from 'qreventos-suite/services';
import meetingService from 'qreventos-suite/meeting';
import archivoAcreditadoService from 'qreventos-suite/archivo.acreditado';
import generalService from 'qreventos-suite/generales';
import eventoServices from 'qreventos-suite/eventos';
import empresaService from 'qreventos-suite/empresas';

class SuiteConfig {
  token = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=';
  clientId = '4634f80b-76d7-4bd2-b271-f81b586073ef-MEET';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;

    meetingService.clientId = this.clientId;
    meetingService.token = this.token;

    archivoAcreditadoService.clientId = this.clientId;
    archivoAcreditadoService.token = this.token;

    generalService.clientId = this.clientId;
    generalService.token = this.token;

    empresaService.clientId = this.clientId;
    empresaService.token = this.token;
  }
}

export default new SuiteConfig();